export type ImportStudyPhase = 'uploading' | 'extracting' | 'reading_dicom' | 'loading_viewer';

export const IMPORT_STUDY_PHASE_LABELS: Record<ImportStudyPhase, string> = {
  uploading: 'Uploading...',
  extracting: 'Extracting...',
  reading_dicom: 'Reading DICOM...',
  loading_viewer: 'Loading Viewer...',
};

export function getImportStudyPhaseLabel(phase: ImportStudyPhase): string {
  return IMPORT_STUDY_PHASE_LABELS[phase];
}
